import { render } from "./Badge.vue?vue&type=template&id=4446bd9a"
import script from "./Badge.vue?vue&type=script&lang=js"
export * from "./Badge.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui-components/Badge.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4446bd9a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4446bd9a', __exports__)) {
    api.reload('4446bd9a', __exports__)
  }
  
  module.hot.accept("./Badge.vue?vue&type=template&id=4446bd9a", () => {
    api.rerender('4446bd9a', render)
  })

}


export default __exports__